<template lang="pug">
  div#app
    drawer(:show="showDrawer", pos='left', tran='push', @change-show="showDrawer = arguments[0]")
      div.drawercontent(slot="drawer")
        .modal-card
          .modal-card-body.titredrawerscroll
            titre-drawer(:id="livreId")
          .modal-card-foot
            router-link.is-primary(@click.native="closeDrawer", v-if="livreEan13", :to="{ name: 'suggestion', params: { ean13: livreEan13 }}", class="button") Faire une recherche à partir de ce livre
      router-view
</template>

<script>
import drawer from '@/components/shared/ui/drawer.vue'
import titreDrawer from '@/components/shared/presentation/titre-drawer.vue'
import eventbus from '@/services/eventbus'

import gql from 'graphql-tag'
import {get} from 'lodash-es'

export default {
  components: {
    drawer,
    titreDrawer,
  },
  data () {
    return {
      showDrawer: false,
      livreId: null,
    }
  },
  mounted () {
    eventbus.$on('book:show-desc', (id) => { this.showDrawer = true; this.livreId = id })
  },
  asyncComputed: {
    async livreEan13 () {
      if (!this.livreId) return
      const { titre } = await this.$apollo.provider.defaultClient.query({
        query: gql`{
          titre(id:"${this.livreId}") {
            id
            livres {
              ean13
            }
          }
        }`,
      }).then(({ data }) => data)
      return get(titre, 'livres[0].ean13')
    },
  },
  methods: {
    closeDrawer () {
      this.showDrawer = false
    },
  },
}
</script>

<style lang="postcss">
@import '~bulma/css/bulma.css';
@import '~vue-multiselect/dist/vue-multiselect.min.css';

@import '~styles/reset.css';
@import '~styles/content.css';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;
  color: #2c3e50;
  margin-top: 60px;*/
  & .title {
    color: #000;
  }
}
.is-dark {
  background-color: #F62459;
  background-size: cover;
  background-image: linear-gradient(rgba(25, 181, 254, 0.6),rgba(255,255,255,.38)),linear-gradient(rgba(0, 0, 0, 0.6),rgba(0, 0, 0, 0.6)), url('/images/bg.jpg');
  background-attachment: fixed;
}

</style>



// WEBPACK FOOTER //
// App.vue?80dba51a